export default "__VITE_ASSET__Czdr7a8m__"